import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService, ParentBusiness } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { FcinputComponent } from '../fcinput';
import { CommonService } from 'fccore2';
import { Sysmenu } from 'fccore2';
/**
 * fc-navmenuèåå¯¼èª
 * ä¸ºé¡µé¢ååè½æä¾å¯¼èªçèååè¡¨ã
 * å¯¼èªèåæ¯ä¸ä¸ªç½ç«ççµé­ï¼ç¨æ·ä¾èµå¯¼èªå¨åä¸ªé¡µé¢ä¸­è¿è¡è·³è½¬ãä¸è¬åä¸ºé¡¶é¨å¯¼èªåä¾§è¾¹å¯¼èªï¼é¡¶é¨å¯¼èªæä¾å¨å±æ§çç±»ç®ååè½ï¼ä¾§è¾¹å¯¼èªæä¾å¤çº§ç»ææ¥æ¶çº³åæåç½ç«æ¶æã
 * äºä»¶
 * 1.éä¸­äºä»¶ï¼select
 * 2.å¼å³äºä»¶ï¼toggle
 */
@Component({
    selector: 'fc-navmenu',
    template: `
    <div class="fc-navmenu" [ngClass]="{'fc-navmenu-small':fcSize === 'small','fc-navmenu-default':fcSize === 'default','fc-navmenu-large':fcSize === 'large'}">
        <ul class="fc-navmenu-ul" nz-menu [nzMode]="_collapsed?'vertical':'inline'" [nzTheme]="fcTheme" [nzInlineCollapsed]="_collapsed">
            <ng-container *ngFor="let menu of fcMenus">
                <li nz-menu-item *ngIf="menu.HASCHILD==='N' && (menu.HIDDEN === undefined || menu.HIDDEN === false)" (click)="_select(menu)" (dbclick)="_select(menu)" [nzSelected]="menu.select" >
                    <span title style="margin-left:-12px">
                        <fc-icon [fcIcon]="menu.MENUICON"></fc-icon>
                        <span class="text">{{menu.MENUNAME}}</span>
                    </span>
                </li>
                <li nz-submenu *ngIf="menu.HASCHILD==='Y'&&menu.P_CHILDMENUS.length!==0  && (menu.HIDDEN === undefined || menu.HIDDEN === false)" [nzOpen]="menu.opened">
                    <span title style="margin-left:-12px">
                        <fc-icon [fcIcon]="menu.MENUICON" ></fc-icon>
                        <span class="text">{{menu.MENUNAME}}</span>
                    </span>
                    <ul>
                        <ng-container *ngFor="let childMenu of menu.P_CHILDMENUS">
                            <li nz-menu-item *ngIf="childMenu.HASCHILD==='N'  && (childMenu.HIDDEN === undefined || childMenu.HIDDEN === false)" (click)="_select(childMenu)" (dbclick)="_select(menu)" [nzSelected]="childMenu.select">
                                <fc-icon [fcIcon]="childMenu.MENUICON"></fc-icon>
                                <span class="text">{{childMenu.MENUNAME}}</span>
                            </li>
                            <li nz-submenu *ngIf="childMenu.HASCHILD==='Y'&&childMenu.P_CHILDMENUS.length!==0  && (childMenu.HIDDEN === undefined || childMenu.HIDDEN === false)"  [nzOpen]="childMenu.opened">
                                <span title>
                                    <fc-icon [fcIcon]="childMenu.MENUICON"></fc-icon>
                                    <span class="text">{{childMenu.MENUNAME}}</span>
                                </span>
                                <ul>
                                    <ng-container *ngFor="let gMenu of childMenu.P_CHILDMENUS">
                                        <li nz-menu-item *ngIf="gMenu.HASCHILD==='N' && (gMenu.HIDDEN === undefined || gMenu.HIDDEN === false)" (click)="_select(gMenu)" (dbclick)="_select(menu)"  [nzSelected]="gMenu.select" style="padding-left: 26px;">
                                            <fc-icon [fcIcon]="gMenu.MENUICON"></fc-icon>
                                            <span class="text">{{gMenu.MENUNAME}}</span>
                                        </li>
                                        <li nz-submenu *ngIf="gMenu.HASCHILD==='Y'&&gMenu.P_CHILDMENUS.length!==0 && (gMenu.HIDDEN === undefined || gMenu.HIDDEN === false)" [nzOpen]="gMenu.opened" style="padding-left: 26px;">
                                            <span title>
                                                <fc-icon [fcIcon]="gMenu.MENUICON"></fc-icon>
                                                <span class="text">{{gMenu.MENUNAME}}</span>
                                            </span>
                                            <ul>
                                                <ng-container *ngFor="let lchildMenu of gMenu.P_CHILDMENUS">
                                                    <li nz-menu-item *ngIf="lchildMenu.HASCHILD==='N' && (lchildMenu.HIDDEN === undefined || lchildMenu.HIDDEN === false)" (click)="_select(lchildMenu)" (dbclick)="_select(menu)"  [nzSelected]="lchildMenu.select" style="padding-left: 36px;">
                                                        <fc-icon [fcIcon]="lchildMenu.MENUICON"></fc-icon>
                                                        <span class="text">{{lchildMenu.MENUNAME}}</span>
                                                    </li>
                                                    <li nz-submenu *ngIf="lchildMenu.HASCHILD==='Y' && (lchildMenu.HIDDEN === undefined || lchildMenu.HIDDEN === false)"  [nzOpen]="lchildMenu.opened" style="padding-left: 36px;">
                                                        <span title>
                                                            <fc-icon [fcIcon]="lchildMenu.MENUICON"></fc-icon>
                                                            <span class="text">{{lchildMenu.MENUNAME}}</span>
                                                        </span>
                                                        <ul >
                                                            <ng-container *ngFor="let ggMenu of lchildMenu.P_CHILDMENUS">
                                                                <li nz-menu-item *ngIf="ggMenu.HASCHILD==='Y' && (ggMenu.HIDDEN === undefined || ggMenu.HIDDEN === false)" (click)="_select(ggMenu)" (dbclick)="_select(menu)"  [nzSelected]="ggMenu.select" style="padding-left: 46px;">
                                                                    <fc-icon [fcIcon]="ggMenu.MENUICON"></fc-icon>
                                                                    <span class="text">{{ggMenu.MENUNAME}}</span>
                                                                </li>
                                                            </ng-container>
                                                        </ul>
                                                    </li>
                                                </ng-container>
                                            </ul>
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                        </ng-container>
                    </ul>
                </li>
            </ng-container>
        </ul>
        <div class="fcnavmenubottom">
            <fc-icon [fcIcon]="_toggleicon" (click)="_onToggle($event)" [fcFontSize]="'12px'"></fc-icon>
        </div>
    <div>
    `,
    styles: [
        `
    .fc-navmenu-fixed{
        position:fixed;
        left:0;
        top:80px;
        z-index:100;
        height:100% - 80px;
        overflow:auto;
        box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);
    }
    :host ::ng-deep .fc-navmenu {
        width:100%;
        height:100%;
        position:relative;
        background-color:#fff;
        padding-top:5px;
    }
    .fc-navmenu-ul{
        height: calc(100% - 24px);
        overflow: auto;
    }
    :host ::ng-deep .logo {
        height: 32px;
        background: #333;
        border-radius: 6px;
        margin: 16px;
    }
    :host ::ng-deep .ant-layout-sider-collapsed .ant-menu-submenu-title:after {
        display: none;
    }
    :host ::ng-deep .ant-menu-inline-collapsed .text{
        display: none;
    }
    :host ::ng-deep .fc-navmenu-ul i{
        margin-right: 5px;
    }
    :host ::ng-deep .ant-menu-inline-collapsed {
        width: 100%;
        text-align: center;
        overflow:visible;
    }
    :host ::ng-deep .ant-layout-sider-collapsed .anticon {
        font-size: 16px;
        margin-left: 8px;
    }
    .fcnavmenubottom{
        background-color: #f5f5f5;
        height: 24px;
        text-align: center;
        line-height: 24px;
        position: absolute;
        bottom: 0px;
        z-index: 999;
        width: 100%;
        left: 0;
    }
    :host ::ng-deep .fcnavmenubottom .icon{
        background-color: #f5f5f5;
        color:#333333;
        cursor: pointer;
    }
    :host ::ng-deep .fcnavmenubottom:hover{
        color:#1890FF;
    }
    :host ::ng-deep .ant-menu-submenu-inline > .ant-menu-submenu-title:after{
        color:#666666;
        right: 20px; 
    }
    :host ::ng-deep .ant-menu-inline-collapsed > .ant-menu-item{
        left: 0;
        text-overflow: clip;
        padding: 0 0px !important;
    }
    :host ::ng-deep .ant-menu-submenu-open>ul {
        text-align: left;
    }
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcnavmenuComponent),
        multi: true
    }]
})
export class FcnavmenuComponent extends FcinputComponent {
    @Input()
    /**éä¸­çèç¹åå®¹IDå¼*/
    fcId: string;
    @Input()
    fcMenus: Fcmenu[];
    /**éç½®*/
    @Input()
    fcOption: MenuOptions;
    @Input()
    fcTheme: string;
    /**å®½é«100%*/
    @Input()
    fcFull: boolean = false;
    /**æ¯å¦æ¶èµ·*/
    _collapsed: boolean;
    isCollapsed = false;
    /**æ¯å¦éä¸­*/
    @Input()
    fcSelected: boolean = false;
    /** æ¶ç¼©å¾æ */
    _toggleicon: string = "fc-icon-left";
    constructor(public provider: ProvidersService, private router: Router) {
        super(provider, 'fc-navmenu');
        this.fcStatus = "opened";
        this._collapsed = false;
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcTheme === undefined) {
            this.fcTheme = "dark";
        }
        if (this.fcOption === undefined) {
            new Error('ç¼ºå°fcOptionå±æ§');
        }
        if (this.fcOption.fcParentValue === undefined) {
            this.fcOption.fcParentValue = '';
        }
        if (this.fcMenus === undefined) {
            this.fcAppid = this.fcOption.fcAppid;
            this.pushDestroy(this.appService.findWithQuery(this.fcAppid, {
                ORDER: this.fcOption.fcOrderby || '',
                WHERE: this.fcOption.fcWhere
            }).subscribe(result => {
                if (result.CODE === '0' || result.DATA.length !== 0) {
                    let ms = CommonService.listtotree(result.DATA, this.fcOption.fcParentValue,
                        this.fcOption.fcChildCode, this.fcOption.fcLabelCode, this.fcOption.fcParentCode);
                    ms.forEach(menu => {
                        if (menu.HASCHILD === 'Y') {
                            menu.opened = false;
                        } else {
                            menu.select = false;
                        }
                    });
                    this.fcMenus = ms;
                }
            }));
        } else {
            this.fcMenus.forEach(menu => {
                if (menu.HASCHILD === 'Y') {
                    menu.opened = false;
                } else {
                    menu.select = false;
                }
            });
        }
    }

    _select(menu: any) {
        menu.select = true;
        this.event('select', menu);
    }
    /**
     * åæ¢å¸å±ï¼å·¦ä¾§å¯¼èªæ¶èµ·,åå®¹åºå®½åº¦æå¼
     * @param event 
     */
    _onToggle(event: any) {
        this.fcStatus = this._collapsed ? 'opened' : "closed";
        this._collapsed = !this._collapsed;
        this._toggleicon = this._collapsed ? 'fc-icon-right' : 'fc-icon-left';
        this.event('toggle', this.fcStatus );
    }
    ngOnDestroy() {
        this.fcMenus = [];
    }
}
export interface MenuOptions {
    /**äº§åId //æå¨äº§åä¼åçº§æé«ï¼å½æäº§åæ¶å¶å®æ¡ä»¶å¿½ç¥*/
    fcPid?: string;
    /**åæ°æ®id*/
    fcAppid?: string; /**åæ°æ®id*/
    /**èç¹æ¾ç¤ºåå®¹*/
    fcLabelCode?: string; /***/
    /** å³èç¶èç¹å­æ®µåç§°*/
    fcParentCode?: string; /**'PARENT',*/
    /** å½åèç¹å­æ®µåç§°*/
    fcChildCode?: string; /**'CODE',*/
    /** æ ¹èç¹æ¡ä»¶*/
    fcWhere?: string; /**'PARENT is null or PARENT=''",*/
    /** å³èç¶èç¹å­æ®µåç§°*/
    fcParentValue?: string; /**'PARENT',*/
    /** æåºå­æ®µ*/
    fcOrderby?: string;
    /** å±å¼å­èç¹*/
    fcOpenChild?: boolean;
};
export interface Fcmenu extends Sysmenu {
    select?: boolean;
    opened?: boolean;
    MENUICON: string;
    MENUNAME: string;
    MENUID: string;
    APPID: string;
    PID: string;
    HASCHILD: string;
}